import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {

  },
}));

const TitleBlock = (props) => {

  const classes = blockStyles();
  const { className, project: { name, subtitle } } = props;
  return (
    <div className = { clsx(classes.root, className) } >
      <h1> { name } </h1>
      <h2> { subtitle } </h2>
    </div>
  );
}

export default TitleBlock;